import React from 'react';
import { WATERMARK_DEFAULT_FONT, watermarkAngle } from '../../utils/watermark';

// Filigrane posé sous le contenu d'une page d'aperçu, comme le PDF le dessine :
// centré, sur la diagonale de la page. Le parent est positionné, a la taille
// de la page (`width` × `height`, en px de l'éditeur) et forme un contexte
// d'empilement : sinon le filigrane passerait aussi sous son fond blanc.
// `onTop` : par-dessus le contenu, pour une page pleine page dont le fond plein
// le cacherait (cf. pageUnderlay du service).
const WatermarkOverlay = ({ watermark, width, height, onTop = false }) => (
  <div
    aria-hidden
    style={{
      position: 'absolute',
      inset: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      pointerEvents: 'none',
      // Au-dessus des éléments de la page, qui empilent leurs propres z-index.
      zIndex: onTop ? 1000 : -1,
    }}
  >
    <span
      data-testid='watermark'
      style={{
        transform: `rotate(${-watermarkAngle({ width, height })}deg)`,
        whiteSpace: 'nowrap',
        fontFamily: watermark.fontFamily || WATERMARK_DEFAULT_FONT,
        fontWeight: watermark.fontWeight || 'normal',
        fontSize: watermark.size,
        lineHeight: 1,
        // Pas de ligatures, comme dans le PDF.
        fontVariantLigatures: 'none',
        color: watermark.color?.style ?? 'black',
        opacity: watermark.opacity,
      }}
    >
      {watermark.text.trim()}
    </span>
  </div>
);

export default WatermarkOverlay;
